import { formatLocaleDateString, getCleanStartorEndDay } from "helpers/utils";
import { useMemo } from "react";
import { useAppSelector } from "store/store";

import type { IDateRangeShortcut } from ".";

interface DateRangeShortcuts {
    periodsShortcuts: IDateRangeShortcut[];
}
/**
 * Shortcuts for dates selector.
 */
export const useDateSelectorShortcuts = (): DateRangeShortcuts => {
    const { periods } = useAppSelector((state) => state.period);

    return useMemo(() => {
        if (!periods) return { periodsShortcuts: [] };

        const activePeriods = periods.filter((item) => item.isActive);
        const lastClosedPeriods = periods.filter((item) => item.isActive === 0).slice(0, 3);

        const periodsRange: IDateRangeShortcut[] = [];
        [...activePeriods, ...lastClosedPeriods].forEach((period) => {
            periodsRange.push({
                rangeKey: period.id,
                label: `${formatLocaleDateString({
                    date: period.periodStart,
                    options: { numeric: true, timeZone: "UTC" },
                })} - ${formatLocaleDateString({
                    date: period.periodEnd,
                    options: { numeric: true, timeZone: "UTC" },
                })}`,
                // Rebuild local Dates matching the UTC calendar day so downstream
                // consumers (e.g. Payment/index.tsx toLocaleDateString("en-CA")) don't
                // shift J-1 for users west of UTC.
                dates: {
                    startDate: getCleanStartorEndDay(period.periodStart),
                    endDate: getCleanStartorEndDay(period.periodEnd, { time: "end" }),
                },
                open: !!period.isActive,
            });
        });

        return { periodsShortcuts: periodsRange } as DateRangeShortcuts;
    }, [periods]);
};
